module.exports = __webpack_public_path__ + "assets/img/files-inventory.482aab42.svg";